import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SupportedLanguages } from 'i18n/i18n';

import { Flag } from '../Flag/Flag';
import { OptionsDropdown, OptionsDropdownOption } from '../OptionsDropdown/OptionsDropdown';

const LanguageDropdown = () => {
   const { t, i18n } = useTranslation();

   const handleLanguageChange = useCallback(
      (lang: string) => {
         i18n.changeLanguage(lang);
      },
      [i18n],
   );

   const currentLanguage = i18n.language as SupportedLanguages;

   const languagesOptions = useMemo<OptionsDropdownOption[]>(
      () =>
         Object.values(SupportedLanguages).map(lang => ({
            value: lang,
            label: t(`languages.${lang}`),
            rightComponent: <Flag lang={lang} />,
            onClick: () => {
               handleLanguageChange(lang);
            },
         })),
      [handleLanguageChange, t],
   );

   return (
      <OptionsDropdown component={<Flag lang={currentLanguage} />} options={languagesOptions} />
   );
};

export default LanguageDropdown;
